import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PlIconModule } from '@app/icon-library/lib/pl-icon.module';
import { TranslateModule } from '@ngx-translate/core';
import { ButtonModule } from '@app/components/button/button.module';
import { FormsModule } from '@angular/forms';
import { MatDialogModule } from '@angular/material/dialog';
import { ModalConfirmEventsOverrideComponent } from '@app/components/blocks/block-lifemap/modalConfirmEventsOverride/modalConfirmEventsOverride.component';
import { CalendarViewHourDisplayPipeModule } from '@app/components/blocks/block-lifemap/pipes/calendarViewHourDisplay/calendarViewHourDisplay.pipe.module';
import { CalendarViewHourDisplayPipe } from '@app/components/blocks/block-lifemap/pipes/calendarViewHourDisplay/calendarViewHourDisplay.pipe';

@NgModule({
  imports: [
    ButtonModule,
    CommonModule,
    FormsModule,
    MatDialogModule,
    PlIconModule,
    TranslateModule,
    CalendarViewHourDisplayPipeModule,
  ],
  providers: [CalendarViewHourDisplayPipe],
  declarations: [ModalConfirmEventsOverrideComponent],
  exports: [ModalConfirmEventsOverrideComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class ModalConfirmEventsOverrideModule {}
